<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    rootRoute: "CollaboratorAffiliatesReports",
  }),

  created() {
    if (this.$route.name == this.rootRoute) {
      this.mainTab();
    }
  },

  watch: {
    $route(val) {
      if (val.name == this.rootRoute) {
        this.mainTab();
      }
    },
  },

  computed: {
    canListOnlineExtract() {
      return this.$permission("61");
    },
    canListRegionalManagers() {
      return this.$permission("13");
    },
    canListLocalManagers() {
      return this.$permission("12");
    },
    canListAffiliates() {
      return this.$permission("14");
    },
    canSeeToPayAffiliates() {
      return this.$permission("105");
    },
    canSeePaymentHistoric() {
      return this.$permission("106");
    },
    canListCpa() {
      return this.$permission("122");
    },
  },

  methods: {
    mainTab() {
      let name = "";

      if (this.canListOnlineExtract) {
        name = "CollaboratorOnlineExtract";
      } else if (this.canListCpa) {
        name = "CollaboratorAffiliatesCpa";
      } else if (this.canListRegionalManagers) {
        name = "CollaboratorAffiliatesRegionalManagersList";
      } else if (this.canListLocalManagers) {
        name = "CollaboratorAffiliatesLocalManagersList";
      } else if (this.canListAffiliates) {
        name = "CollaboratorAffiliatesAffiliatesList";
      } else if (this.canSeeToPayAffiliates) {
        name = "CollaboratorAffiliatesPayments";
      } else if (this.canSeePaymentHistoric) {
        name = "CollaboratorAffiliatesPaymentsHistoric";
      }

      this.$router.push({ name });
    },
  },
};
</script>
